module.exports = __webpack_public_path__ + "static/img/p-22.a973093.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-22.png
// module id = qwbJ
// module chunks = 0